// extracted by mini-css-extract-plugin
export default {"tabs":"TabNav_tabs__adw2j"};